import FormContainer from "../components/common/FormElements/FormContainer";
import FormHeader from "../components/common/FormElements/FormHeader";
import Input from "../components/common/FormElements/Input";
import SubmitButton from "../components/common/FormElements/SubmitButton";
import { ChangeEvent, useState, FormEvent } from "react";

type ResetDataType = {
  password: string;
};

const Reset = () => {
  const [data, setData] = useState<ResetDataType>({
    password: "",
  });

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formHander = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(data);
  };

  return (
    <FormContainer>
      <FormHeader
        labelText="Create New Password"
        subheading={"Please create a new password that you not used before."}
      />
      <form
        className="w-full flex flex-col gap-5"
        onSubmit={(e: FormEvent<HTMLFormElement>) => formHander(e)}
      >
        <Input
          inputType="password"
          placeholder="Create New Password"
          icon="fa-solid fa-key"
          inputName="password"
          value={data.password}
          handler={changeHandler}
        />
        <SubmitButton buttonLabel="Reset" isLoading={false} />
      </form>
    </FormContainer>
  );
};

export default Reset;
